'use client';

import { Suspense } from 'react';
import Filters from './Filters';
import { Bikepark, Snowpark } from '@/types';
import { useTranslations } from 'next-intl';

interface FiltersWrapperProps {
  parks: (Bikepark | Snowpark)[];
  onFilterChange: (filtered: (Bikepark | Snowpark)[]) => void;
  type: 'bikepark' | 'snowpark';
  onResetRef?: React.MutableRefObject<(() => void) | null>;
}

export default function FiltersWrapper(props: FiltersWrapperProps) {
  const t = useTranslations('filters');

  return (
    <Suspense fallback={<div>{t('loading')}</div>}>
      <Filters {...props} />
    </Suspense>
  );
}
